import classNames from 'classnames';
import React, { ButtonHTMLAttributes, LegacyRef } from 'react';
import styles from '../styles/mainButton.module.scss';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  secondary?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const MainButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { loading, secondary, ...props },
    ref: LegacyRef<HTMLButtonElement> | undefined
  ) => {
    return (
      <button
        {...props}
        type={props.type ? props.type : 'button'}
        className={classNames(styles.mainBtn, props.className, {
          [styles.secondary]: secondary,
          [styles.loading]: loading,
        })}
        ref={ref}
      >
        {props.children}
      </button>
    );
  }
);

export default MainButton;
